import React from 'react';
export function Footer() {
  return <footer className="bg-black py-12 border-t border-white/10" data-id="element-187">
      <div className="max-w-7xl mx-auto px-6" data-id="element-188">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8" data-id="element-189">
          <div className="mb-6 md:mb-0 text-center md:text-left" data-id="element-190">
            <div className="text-2xl font-serif font-bold tracking-widest text-white mb-2" data-id="element-191">
              TT<span className="text-gold-500" data-id="element-192">vip</span>
            </div>
            <p className="text-gray-600 text-xs uppercase tracking-widest" data-id="element-193">
              Singapore Premier Companion Platform
            </p>
          </div>

          <div className="flex space-x-8 text-sm text-gray-500" data-id="element-194">
            <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-195">
              Home
            </a>
            <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-196">
              About
            </a>
            <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-197">
              Services
            </a>
            <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-198">
              Contact
            </a>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 mb-8" data-id="element-199">
          <p className="text-xs text-gray-600 uppercase tracking-widest mb-3 text-center md:text-left" data-id="element-200">
            友站链接
          </p>
          <div className="flex flex-wrap justify-center md:justify-start gap-x-6 gap-y-2 text-sm text-gray-500" data-id="element-201">
            <a href="https://ttvip-64.com/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-202">
              ttvip-64.com
            </a>
            <a href="https://shiok27.com/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-203">
              shiok27.com
            </a>
            <a href="https://xfy01.net/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-204">
              xfy01.net
            </a>
            <a href="https://sgharem6.net/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-205">
              sgharem6.net
            </a>
            <a href="https://qc52.me/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-206">
              qc52.me
            </a>
            <a href="https://geylang777.info/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-207">
              geylang777.info
            </a>
            <a href="https://geylang666.me/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-208">
              geylang666.me
            </a>
            <a href="https://isyou.net/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-209">
              isyou.net
            </a>
            <a href="https://ttvip-62.site/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-210">
              ttvip-62.site
            </a>
            <a href="https://shiok26.site/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-211">
              shiok26.site
            </a>
            <a href="https://sgharem.site/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-212">
              sgharem.site
            </a>
            <a href="https://xfy8.com/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-213">
              xfy8.com
            </a>
            <a href="https://sglonelyguy.me/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-214">
              sglonelyguy.me
            </a>
            <a href="https://ttvip.life/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-215">
              ttvip.life
            </a>
            <a href="https://locanto.space/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-216">
              locanto.space
            </a>
            <a href="https://kkbaby.site/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-217">
              kkbaby.site
            </a>
            <a href="https://sgbeautycastle.live/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-218">
              sgbeautycastle.live
            </a>
            <a href="https://shiok8.xyz/" target="_blank" rel="noopener noreferrer" className="hover:text-gold-400 transition-colors" data-id="element-219">
              shiok8.xyz
            </a>
          </div>
        </div>

        {/* SEO Rich Text Block */}
        <div className="border-t border-white/5 pt-8 mb-8" data-id="element-220">
          <div className="max-w-4xl mx-auto" data-id="element-221">
            <h3 className="text-[11px] text-gray-700 uppercase tracking-widest mb-4 text-center md:text-left" data-id="element-222">
              关于TTVIP新加坡伴游平台
            </h3>
            <div className="text-[11px] text-gray-700/80 leading-relaxed space-y-3" data-id="element-223">
              <p data-id="element-224">
                TTVIP是新加坡领先的高端伴游服务平台，自2014年创立以来，始终致力于为客户提供最优质的伴游体验。作为新加坡最受信赖的伴游品牌，TTVIP汇聚了来自日本、韩国、欧美、越南、中国等全球各地的500余位精选佳丽，满足不同客户的品味与需求。
              </p>
              <p data-id="element-225">
                TTVIP提供多元化的专业伴游服务，包括新加坡商务伴游、旅行伴游、私人派对伴游以及个性化定制服务。每一位TTVIP佳丽均经过严格的多轮面试与背景审核，所有照片真实可靠，确保客户获得最真实、最安全的伴游体验。我们采用端到端加密通讯技术，绝对保护客户隐私信息。
              </p>
              <p data-id="element-226">
                选择TTVIP新加坡伴游平台，您将享受24小时专属管家服务、真实照片验证、严格安全保障以及99%客户好评率的品质承诺。无论您是商务出行需要专业伴游，还是旅行度假寻找完美伴侣，TTVIP都能为您量身定制独一无二的尊享体验。十年品牌沉淀，50000+尊贵客户的共同选择——TTVIP，新加坡顶级伴游平台。
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-700" data-id="element-227">
          <p data-id="element-228">&copy; 2024 TTvip Singapore. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-229">
            <a href="#" className="hover:text-gray-500" data-id="element-230">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-500" data-id="element-231">
              Terms of Service
            </a>
            <a href="#" className="hover:text-gray-500" data-id="element-232">
              Disclaimer
            </a>
          </div>
        </div>
      </div>
    </footer>;
}